import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeJsonPipe } from './pipes/safe-json/safe-json.pipe';
import { ContentStatusComponent } from './content-status/content-status.component';
import { WithLoadingPipe } from './pipes/with-loading/with-loading.pipe';



@NgModule({
  declarations: [
    SafeJsonPipe,
    ContentStatusComponent,
    WithLoadingPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SafeJsonPipe,
    ContentStatusComponent,
    WithLoadingPipe
  ]
})
export class SharedModule { }
